var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlannedRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 960 960",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M760,840q-39,0 -70,-22.5T647,760L440,760q-66,0 -113,-47t-47,-113q0,-66 47,-113t113,-47h80q33,0 56.5,-23.5T600,360q0,-33 -23.5,-56.5T520,280L313,280q-13,35 -43.5,57.5T200,360q-50,0 -85,-35t-35,-85q0,-50 35,-85t85,-35q39,0 69.5,22.5T313,200h207q66,0 113,47t47,113q0,66 -47,113t-113,47h-80q-33,0 -56.5,23.5T360,600q0,33 23.5,56.5T440,680h207q13,-35 43.5,-57.5T760,600q50,0 85,35t35,85q0,50 -35,85t-85,35ZM200,280q17,0 28.5,-11.5T240,240q0,-17 -11.5,-28.5T200,200q-17,0 -28.5,11.5T160,240q0,17 11.5,28.5T200,280Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannedRoute);
export default __webpack_public_path__ + "static/media/planned_route.5ac0204c.svg";
export { ForwardRef as ReactComponent };